import React from 'react';

const Profile = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Educator Profile</h1>
      <p className="text-gray-600">Profile management coming soon...</p>
    </div>
  );
};

export default Profile;